<template>
  <div>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <h2 class="text-center text-space"> {{ translatedFields['telehealth_appointment_setup'] }} </h2>
          <br>
          <p v-html="this.$store.state.site.patient_disclaimer_final"></p>
          <br><br>
          <label class="control-label">
            {{ translatedFields['choose_time_period'] }}
          </label><br>
          <div class="row">
            <div class="col-md-4">
              <el-select size="large"
                        data-vv-as="Time Period"
                        v-validate="modelValidations.callingSchedule"
                        placeholder="Select when to be called back"
                        name="callingSchedule"
                        v-model="model.callingSchedule">
                <el-option v-for="option in scheduleList"
                          class="select-danger"
                          :value="option.value"
                          :label="translateFields(option)"
                          :key="option.label">
                </el-option>
              </el-select>
              <small class="text-danger" v-show="callingSchedule.invalid">
                {{ getError('callingSchedule') }}
              </small>
            </div>
          </div>
        <br><br>
        <p v-if="!callingSchedule.invalid" v-html="telehealth_consent"></p>
      <!-- <p-checkbox  v-model="model.agreed" name="agreed" v-validate="modelValidations.agreed">I agree</p-checkbox>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vee-validate'

export default {
  data () {
    return {
      title: process.env.LAB_NAME,
      scheduleList: [
        {value: 'Morning', label: 'Morning'},
        {value: 'Afternoon', label: 'Afternoon'},
        {value: 'Any', label: 'Any'}
      ],
      model: {
        notify_patient: '',
        callingSchedule: null
      },
      modelValidations: {
        callingSchedule: {
          required: true
        }
      },
      wizardModel: {},
      fields_en: {
        telehealth_appointment_setup: 'Telehealth Appointment Setup',
        choose_time_period: 'Choose Time Period'
      },
      translatedFields: ''
    }
  },
  methods: {
    translateFields (option) {
      let field = option.label.toLowerCase()
      if (this.$store.state.lang.value === 'ES' && this.$store.state.translation_es[field]) {
        return this.$store.state.translation_es[field]
      } else {
        if (this.$store.state.lang.value === 'ZH' && this.$store.state.translation_zh[field]) {
          return this.$store.state.translation_zh[field]
        } else {
          return option.label
        }
      }
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validate () {
      this.model.notify_patient = this.$store.state.site.notify_patient
      return this.$validator.validateAll()
    },
    checkLanguage () {
      if (this.$store.state.lang.value === 'ES') {
        this.translatedFields = this.$store.state.translation_es
      } else {
        if (this.$store.state.lang.value === 'ZH') {
          this.translatedFields = this.$store.state.translation_zh
        } else {
          this.translatedFields = this.fields_en
        }
      }
    }
  },
  computed: {
    ...mapFields(['callingSchedule']),
    telehealth_consent () {
      if (this.$store.state.lang.value === 'ES' && this.$store.state.site.patient_telehealth_consent_es) {
        return this.$store.state.site.patient_telehealth_consent_es
      } else {
        if (this.$store.state.lang.value === 'ZH' && this.$store.state.site.patient_telehealth_consent_zh) {
          return this.$store.state.site.patient_telehealth_consent_zh
        } else {
          return this.$store.state.site.patient_telehealth_consent
        }
      }
    },
    language () {
      this.checkLanguage()
      return this.$store.state.lang.value
    },
    spanishFields () {
      return this.$store.state.translation_es
    },
    chineseFields () {
      return this.$store.state.translation_zh
    }
  },
  watch: {
    language () {
      this.checkLanguage()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/SubmissionStep.vue